var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-area bg-white flex-shrink-0 p-sm-2 d-flex align-items-center transition-ease-out",class:_vm.classObject},[_c('button',{staticClass:"btn text-secondary-blue",class:{ invisible: _vm.hideButton },on:{"click":_vm.toggle}},[_c('Icon',{attrs:{"type":_vm.iconType,"size":"24"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }